<script>
export default {
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      default: `Label`,
    },
    maxValue: {
      type: [Number, String],
      default: 1,
    },
    value: {
      type: [Number, String],
      default: 1,
    },
    minValue: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    step() {
      return this.maxValue * 1 > 2 ? 1 : 0.01
    },
    min() {
      return this.minValue || this.step
    },
  },
  methods: {
    inputValue({ target: { value } }) {
      this.$emit(`input`, value * 1)
    },
    attachMouseMove({ target }) {
      target.addEventListener(`mousemove`, this.inputValue)
    },
    removeMouseMove({ target }) {
      target.removeEventListener(`mousemove`, this.inputValue)
    },
  },
  render() {
    return this.$scopedSlots.default({
      label: `${this.name[0].toUpperCase()}${this.name.slice(1)}`,
      inputBindings: {
        ...this.$attrs,
        max: this.maxValue,
        min: this.min,
        step: this.step,
        value: this.value,
      },
      inputEventHandlers: {
        ...this.$listeners,
        input: this.inputValue,
        mousedown: this.attachMouseMove,
        mouseup: this.removeMouseMove,
      },
    })
  },
}
</script>
